import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import setRef from '../../utils/setRef';
import HTMLElementType from '../../utils/HTMLElementType';
import useEnhancedEffect from '../../hooks/useEnhancedEffect';

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

const Portal = React.forwardRef((props, ref) => {
  const { children, container } = props;
  const [mountNode, setMountNode] = useState(null);

  useEnhancedEffect(() => {
    setMountNode(getContainer(container) || document.body);
  }, [container]);

  useEnhancedEffect(() => {
    if (mountNode) {
      setRef(ref, mountNode);
      return () => {
        setRef(ref, null);
      };
    }
    return undefined;
  }, [ref, mountNode]);

  return mountNode ? createPortal(children, mountNode) : mountNode;
});

Portal.displayName = 'Portal';

Portal.propTypes = {
  children: PropTypes.node,
  container: PropTypes.oneOfType([
    HTMLElementType,
    PropTypes.func,
  ]),
};

Portal.defaultProps = {};

export { Portal };